import React, { ChangeEvent, useCallback, useRef } from "react";
import { IconButton, Menu as MenuMui, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

interface Props {
  icon?: JSX.Element;
  onAddFile?: (e: ChangeEvent<HTMLInputElement>) => void;
  onDelete?: () => void;
}
const ITEM_HEIGHT = 48;

export const Menu: React.FC<Props> = ({ icon, onAddFile, onDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onAttachCLick = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.click();
      handleClose();
    }
  }, [inputRef]);

  return (
    <div className="task-menu">
      <IconButton
        size="sm"
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        {icon || <MoreVertIcon />}
      </IconButton>
      <MenuMui
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button"
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch"
          }
        }}
      >
        {onAddFile && (
          <MenuItem
            onClick={onAttachCLick}
            sx={{
              display: "flex",
              gap: "10px",
              fontSize: "15px"
            }}
          >
            <AttachFileIcon />
            <span>Add Attachment</span>
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem
            onClick={() => {
              handleClose();
              onDelete();
            }}
            sx={{
              display: "flex",
              gap: "10px",
              fontSize: "15px"
            }}
          >
            <DeleteOutlineIcon />
            <span>Delete Task</span>
          </MenuItem>
        )}
        {/* {options.map((option) => (
          <MenuItem key={option} selected={option === 'Pyxis'} onClick={handleClose}>
            {option}
          </MenuItem>
        ))} */}
      </MenuMui>
      <input onChange={onAddFile} ref={inputRef} hidden type="file" />
    </div>
  );
};
